const sendCounterEvent = ({ name, params }) => {
  if (!window.ym) {
    console.warn('Yandex Metrica is not installed');
    return;
  }
  window.ym(process.env.VUE_APP_YM_ID, 'reachGoal', name, params);
};

export { sendCounterEvent };
